import * as React from "react";
import { forwardRef } from "react";
const SvgCloseIcon = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 23, height: 23, fill: "currentColor", viewBox: "0 0 23 23", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M.201 20.08 20 .283l2.828 2.828L3.03 22.91z" }), /* @__PURE__ */ React.createElement("path", { d: "M3.2.081 23 19.88l-2.829 2.828L.373 2.91z" }));
const ForwardRef = forwardRef(SvgCloseIcon);
export default ForwardRef;
